import React from 'react';
import { Snackbar as MuiSnackbar, Alert as MuiAlert } from '@mui/material';
import { useSnackbar } from 'src/hooks/useSnackbar';
import useIsMobile from 'src/hooks/useIsMobile';

const Alert = React.forwardRef(function Alert(props, ref) {
    const { severity, ...rest } = props;

    return <MuiAlert 
            elevation={6} 
            ref={ref} 
            variant="filled" 
            {...rest} 
            sx={{
                backgroundColor: theme => {
                    if (severity === 'success') return theme.palette.primary.main;
                    if (severity === 'error') return theme.palette.error.main;
                    if (severity === 'warning') return theme.palette.warning.main;
                    return theme.palette.info.main;
                    },
                    color: theme => theme.palette.common.white,
                }}
            />;
});

const SnackbarComponent = () => {
  const { snackbar, closeSnackbar } = useSnackbar();
  const isMobile = useIsMobile();

  return (
    <MuiSnackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={closeSnackbar}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: isMobile ? 'center' : 'left',
        }}
        sx={{
            marginBottom: isMobile ? '70px' : '40px',
            marginLeft: isMobile ? 0 : '10px',
            width: 'auto',
            zIndex: 10001
        }}
        >
            <Alert 
                onClose={closeSnackbar} 
                severity={snackbar.severity} 
                sx={{ width: '100%' }}>

                    {snackbar.message}

            </Alert>
    </MuiSnackbar>

  );
};

export default SnackbarComponent;
